<template lang="pug">
  .component-zone-cost
    .card
      .inner-content
        .row
          .column.shrink.pl-0
            dropdown(:icon="'fa fa-ellipsis-v fa-2x action'", :position="'top'")
              ZoneConfigButtons(:item="item", @itemUpdated="$emit('itemUpdated')")
          .column
            .label ZC{{item.id}}
            .field-value Z{{item.zone.id}} {{item.zone.name}}
            //.field-value {{item.type ==='OUT' ?'Starts a reservation in the area' :'Ends a reservation in the area'}} {{item.type}}
          .column
            .label Cost on Start
            .field-value(v-if="item.common_cost_start") CC{{item.common_cost_start.id}} {{item.common_cost_start.reason}}
          .column
            .label Cost on End
            .field-value(v-if="item.common_cost_end") CC{{item.common_cost_end.id}} {{item.common_cost_end.reason}}
          .column
            .label Type
            .fiel-value {{item.type}}
          .column
            .label Max vehicles
            .fiel-value {{item.max_vehicles}}
          .column
            .label Min fuel level
            .fiel-value {{item.min_fuel_level}}
          .column
            .label Max speed
            .fiel-value {{item.max_speed}}
          .column
            router-link(:to="{name:'edit-zone-config', params:{id:item.id}}" )
              i.fa.fa-angle-right.fa-3x.action


</template>

<script>
  import ZoneConfigButtons from '../structure/ui/actions/ZoneConfigButtons'
  import Dropdown from '../structure/foundation/Dropdown'

  export default {
    name: 'ZoneCost',
    components: {Dropdown, ZoneConfigButtons},
    props: ['item']
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// ZoneConfig.vue?1f7fd63f